import { IDonor } from '@nkr/models/index';
import { TableWrapper } from './styles';

interface IProps {
    list: IDonor[]
}

const AdpMissingVoucherHolders = (props: IProps) => {
    return (
        <TableWrapper className='table table-condensed table-striped table-bordered'>
            <thead>
                <tr>
                    <th>Registered</th>
                    <th>Alias</th>
                    <th>Gender</th>
                    <th>Age</th>
                    <th>ABO</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {props.list.map((item, index) => (
                    <tr key={index}>
                        <td>{item.dateRegistered}</td>
                        <td>
                            <a href={`center/${item.centerId}/donor/${item.id}/profile/vouchers`}>
                                {item.alias}
                            </a>
                        </td>
                        <td>{item.gender}</td>
                        <td>{item.age}</td>
                        <td>{item.bloodType}</td>
                        <td>{item.pairStatus}</td>
                    </tr>
                ))}
            </tbody>
        </TableWrapper>
    );
}

export default AdpMissingVoucherHolders;